export const numberToWords = (number) => {
  if (!number || isNaN(number) || number === 0) return "Không đồng";
  const strNumber = Math.round(number).toString();
  const chuSo = ["không", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];
  const tien = ["", "nghìn", "triệu", "tỷ", "nghìn tỷ", "triệu tỷ"];

  let row = [],
    i = 0;
  for (i = strNumber.length; i > 0; i -= 3) {
    row.push(strNumber.substring(i - 3, i));
  }

  const docHangChuc = (so, daydu) => {
    let chuoi = "";
    let chuc = Math.floor(so / 10);
    let donvi = so % 10;
    if (chuc > 1) {
      chuoi = " " + chuSo[chuc] + " mươi";
      if (donvi === 1) chuoi += " mốt";
    } else if (chuc === 1) {
      chuoi = " mười";
      if (donvi === 1) chuoi += " một";
    } else if (daydu && donvi > 0) {
      chuoi = " linh";
    }
    if (donvi === 5 && chuc >= 1) chuoi += " lăm";
    else if (donvi > 1 || (donvi === 1 && chuc === 0)) chuoi += " " + chuSo[donvi];
    return chuoi;
  };

  const docKhoi = (so, daydu) => {
    let chuoi = "";
    let tram = Math.floor(so / 100);
    so = so % 100;
    if (daydu || tram > 0) {
      chuoi = " " + chuSo[tram] + " trăm";
      chuoi += docHangChuc(so, true);
    } else {
      chuoi = docHangChuc(so, false);
    }
    return chuoi;
  };

  const docSo = (so) => {
    let ketQua = "";
    let viTri = row.length - 1;
    for (let i = viTri; i >= 0; i--) {
      let soNhom = parseInt(row[i]);
      if (soNhom > 0) {
        let cachDoc = docKhoi(soNhom, i !== viTri);
        ketQua += cachDoc + " " + tien[i];
      }
    }
    return ketQua.trim().charAt(0).toUpperCase() + ketQua.trim().slice(1);
  };

  return docSo(number) + " đồng chẵn";
};

const fmt = (n) => (n ? new Intl.NumberFormat("vi-VN").format(n) : "");

export const getPrintTemplate = ({ headerInfo, rows, totals }) => {
  const rowsHtml = rows
    .map(
      (row, i) => `
      <tr>
        <td class="text-center">${i + 1}</td>
        <td>${row.fullName || ""}</td>
        <td class="text-center">${row.rank || ""}</td>
        <td class="text-center">${row.coeff || ""}</td>
        <td class="text-right">${row.prodQty || ""}</td>
        <td class="text-right">${row.prodMoney || ""}</td>
        <td class="text-right">${row.timeDays || ""}</td>
        <td class="text-right">${row.timeMoney || ""}</td>
        <td class="text-right">${row.leaveDays || ""}</td>
        <td class="text-right">${row.leaveMoney || ""}</td>
        <td class="text-right">${row.allowanceSalary || ""}</td>
        <td class="text-right">${row.allowanceOther || ""}</td>
        <td class="text-right bold" style="background-color: #f9f9f9;">${fmt(row.totalGross)}</td>
        <td class="text-right">${row.advance || ""}</td>
        <td class="text-right">${row.bhxh || ""}</td>
        <td class="text-right">${row.deductOther || ""}</td>
        <td class="text-right">${row.tax || ""}</td>
        <td class="text-right bold" style="background-color: #e8f5e9; color: darkgreen;">${fmt(
          row.netPay
        )}</td>
        <td></td>
      </tr>
    `
    )
    .join("");

  return `
    <html>
      <head>
        <title>In Bảng Lương</title>
        <style>
          @media print {
            @page { margin: 10mm; size: landscape; }
          }
          body {
            font-family: "Times New Roman", Times, serif;
            color: #000;
            padding: 20px;
            font-size: 12px;
          }
          .header-top { display: flex; justify-content: space-between; margin-bottom: 20px; }
          .title-box { text-align: center; margin: 20px 0; }
          .title-main { font-size: 18px; font-weight: bold; margin: 0; text-transform: uppercase; }
          table { width: 100%; border-collapse: collapse; margin-top: 10px; }
          th, td { border: 1px solid #000; padding: 4px; }
          th { text-align: center; font-weight: bold; vertical-align: middle; }
          .text-center { text-align: center; }
          .text-right { text-align: right; }
          .bold { font-weight: bold; }
          .footer { display: flex; justify-content: space-between; margin-top: 30px; text-align: center; }
        </style>
      </head>
      <body>
        <div class="header-top">
          <div style="width: 60%;">
            <div class="bold">Đơn vị: ${headerInfo.unit}</div>
            <div class="bold">Bộ phận: ${headerInfo.department}</div>
          </div>
          <div style="text-align: center; width: 40%;">
            <div class="bold">Mẫu số: 01 - LĐTL</div>
            <div style="font-style: italic; font-size: 11px;">
              (Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)
            </div>
          </div>
        </div>

        <div class="title-box">
          <h2 class="title-main">BẢNG THANH TOÁN TIỀN LƯƠNG</h2>
          <div style="font-style: italic; margin-top: 5px;">
            Tháng ${headerInfo.month} năm ${headerInfo.year}
          </div>
          <div class="text-right" style="margin-top: 10px;">
            Số: ${headerInfo.docNumber}
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th rowspan="2">STT</th>
              <th rowspan="2" style="width: 120px;">Họ và tên</th>
              <th rowspan="2">Ngạch bậc<br/>lương, CV</th>
              <th rowspan="2">Hệ<br/>số</th>
              <th colspan="2">Lương sản phẩm</th>
              <th colspan="2">Lương thời gian</th>
              <th colspan="2">Nghỉ việc<br/>hưởng % lương</th>
              <th rowspan="2">Phụ cấp<br/>lương</th>
              <th rowspan="2">Phụ cấp<br/>khác</th>
              <th rowspan="2">Tổng<br/>số</th>
              <th rowspan="2">Tạm<br/>ứng</th>
              <th colspan="3">Các khoản khấu trừ</th>
              <th rowspan="2">Thực<br/>lĩnh</th>
              <th rowspan="2">Ký<br/>nhận</th>
            </tr>
            <tr>
              <th>Số SP</th>
              <th>Thành tiền</th>
              <th>Số công</th>
              <th>Thành tiền</th>
              <th>Số công</th>
              <th>Thành tiền</th>
              <th>BHXH</th>
              <th>Khác</th>
              <th>Thuế</th>
            </tr>
          </thead>
          <tbody>
            ${rowsHtml}
            <tr style="font-weight: bold; background-color: #eee;">
              <td colspan="4" class="text-center">Cộng</td>
              <td class="text-right"></td>
              <td class="text-right">${fmt(totals.prodMoney)}</td>
              <td class="text-right"></td>
              <td class="text-right">${fmt(totals.timeMoney)}</td>
              <td class="text-right"></td>
              <td class="text-right">${fmt(totals.leaveMoney)}</td>
              <td class="text-right">${fmt(totals.allowanceSalary)}</td>
              <td class="text-right">${fmt(totals.allowanceOther)}</td>
              <td class="text-right">${fmt(totals.totalGross)}</td>
              <td class="text-right">${fmt(totals.advance)}</td>
              <td class="text-right">${fmt(totals.bhxh)}</td>
              <td class="text-right">${fmt(totals.deductOther)}</td>
              <td class="text-right">${fmt(totals.tax)}</td>
              <td class="text-right" style="color: darkgreen;">${fmt(totals.netPay)}</td>
              <td></td>
            </tr>
          </tbody>
        </table>

        <div style="margin-top: 20px; font-style: italic;">
          Tổng số tiền (viết bằng chữ): <span class="bold">${numberToWords(totals.netPay)}</span>
          ......................................................................................
        </div>

        <div class="footer">
          <div style="width: 25%;">
            <div class="bold">Người lập bảng</div>
            <br/>
            <i style="font-size: 13px;">(Ký, họ tên)</i>
          </div>
          <div style="width: 25%;">
            <div class="bold">Kế toán trưởng</div>
            <br/>
            <i style="font-size: 13px;">(Ký, họ tên)</i>
          </div>
          <div style="width: 30%;">
            <div style="font-style: italic; margin-bottom: 5px;">
              Ngày ${headerInfo.day} tháng ${headerInfo.month} năm ${headerInfo.year}
            </div>
            <div class="bold">Giám đốc</div>
            <br/>
            <i style="font-size: 13px;">(Ký, họ tên)</i>
          </div>
        </div>
        <script>
          window.onload = function() {
            window.print();
          };
        </script>
      </body>
    </html>
  `;
};
